import React from "react";
import { node, shape, string } from "prop-types";
import { useIntl } from "react-intl";
import Icon from "../../../../components/Icon";
import { mergeClasses } from "@magento/venia-ui/lib/classify";
import defaultClasses from "./navTrigger.module.scss";
import { useNavigationTrigger } from "@magento/peregrine/lib/talons/Header/useNavigationTrigger";
import { useHistory } from "react-router";
import { pushToMiScusi } from "../../../../components/LinkBetween/miScusiAndTakeAwayUtils";

/**
 * A component that toggles the navigation menu.
 */
var NavigationTrigger = props => {
  var {
    formatMessage
  } = useIntl();
  var {
    handleOpenNavigation
  } = useNavigationTrigger();
  var history = useHistory();
  var {
    checkout
  } = props;
  var classes = mergeClasses(defaultClasses, props.classes);
  return !checkout ? /*#__PURE__*/React.createElement("button", {
    className: classes.root,
    "aria-label": formatMessage({
      id: "navigationTrigger.ariaLabel",
      defaultMessage: "Toggle navigation panel"
    }),
    onClick: () => {
      history.goBack();
      console.log(history);
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "icon-arrow-left",
    color: "white",
    header: true
  })) : /*#__PURE__*/React.createElement("button", {
    className: classes.root,
    onClick: () => pushToMiScusi(history.push, formatMessage({
      id: "url.key.ti_serve_aiuto"
    }))
  }, /*#__PURE__*/React.createElement(Icon, {
    className: "navIcon",
    name: "icon-assitance",
    color: "white",
    header: true
  }));
};
NavigationTrigger.propTypes = {
  children: node,
  classes: shape({
    root: string
  })
};
NavigationTrigger.defaultProps = {
  checkout: false
};
export default NavigationTrigger;